function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-8a671af6\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Coupon.vue")
}
var normalizeComponent = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Coupon.vue"
import __vue_script__ from "!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Coupon.vue"
/* template */
import __vue_template__ from "!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8a671af6\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Coupon.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/page/page/diy/params/Coupon.vue
// module id = null
// module chunks = 